import React, { ChangeEvent, useEffect, useRef, useState } from "react";
import Input from "common/Inputs/Input.tsx";
import CloseOutlined from "@ant-design/icons/CloseOutlined";
import SearchOutlined from "@ant-design/icons/SearchOutlined";
import { HEADER_ICON_SIZE } from "@shared/common/Themes/constants.ts";
import { useTheme } from "styled-components";
import { InputRef } from "antd/es/input";
import { Search, X } from "lucide-react";
import LookIcon from "common/Icons/LookIcon";
import { NEW_LOOK_ICON_STROKE } from "common/NewLook/layout";

export const useSelectSearch = () => {
  const theme = useTheme();
  const [isSearch, setIsSearch] = useState(false);
  const [searchValue, setSearchValue] = useState<string | undefined>();
  const inputRef = useRef<InputRef>(null);

  useEffect(() => {
    if (isSearch) {
      inputRef.current?.focus();
    }
  }, [isSearch]);

  const openSearch = () => setIsSearch(true);
  const closeSearch = () => {
    setSearchValue("");
    setIsSearch(false);
  };

  const getSearchComponent = () => {
    if (isSearch) {
      return (
        <Input
          ref={inputRef}
          onChange={(e: ChangeEvent<HTMLInputElement>) =>
            setSearchValue(e.target.value)
          }
          style={{ maxWidth: 200 }}
          suffix={
            <LookIcon
              classic={
                <CloseOutlined
                  style={{ color: theme.colors.secondaryText }}
                  onClick={closeSearch}
                />
              }
              newLook={
                <X
                  size={16}
                  strokeWidth={NEW_LOOK_ICON_STROKE}
                  color={theme.colors.secondaryText}
                  style={{ cursor: "pointer" }}
                  onClick={closeSearch}
                />
              }
            />
          }
        />
      );
    } else {
      return (
        <LookIcon
          classic={
            <SearchOutlined
              style={{
                fontSize: HEADER_ICON_SIZE,
                color: theme.colors.secondaryText,
              }}
              onClick={openSearch}
            />
          }
          newLook={
            <Search
              size={20}
              strokeWidth={NEW_LOOK_ICON_STROKE}
              color={theme.colors.secondaryText}
              style={{ cursor: "pointer" }}
              onClick={openSearch}
            />
          }
        />
      );
    }
  };

  return {
    isSearch,
    setIsSearch,
    searchValue,
    setSearchValue,
    searchComponent: getSearchComponent(),
  };
};
